<div class="panel">
  <div class="big-div">
    <span class="icon aprovado white"></span>
    <p class="text-white">A FICHA <span class="ficha-id">{{ proposta?.id }}</span> FOI FINALIZADA E ENVIADO PARA ANÁLISE.</p>
  </div>
  <div class="small-div">
    <span class="icon aguardando-analise"></span>
    <div>
      <p class="text-white"><strong>ANÁLISE DIRETA</strong></p>
      <p class="text-white">Espera máxima: 10min</p>
    </div>
  </div>
</div>
<div class="panel panel-small">
  <form class="forms">
    <div class="form-group">
      <span class="icon loja"></span>
      <div class="inputs">
        <label for="produto">PRODUTO ESCOLHIDO</label>
        <p><small>{{ produtoEscolhido }}</small></p>
      </div>
    </div>
  </form>
</div>
<div class="panel panel-small">
  <form class="forms">
    <div class="form-group">
      <span class="icon pessoa"></span>
      <div class="inputs">
        <label for="cliente">CLIENTE</label>
        <p><small> <span class="name">{{ nomeCliente }}</span> - CPF: {{ cpfCliente }}</small></p>
      </div>
    </div>
  </form>
</div>
<div class="panel panel-small" *ngIf="hasAvalistas">
  <form class="forms">
    <div class="form-group">
      <span class="icon pessoas"></span>
      <div class="inputs">
        <label for="cliente">AVALISTAS</label>
        <div *ngFor="let avalista of avalistas">
          <p><small> <span class="name">{{ avalista.nomeCliente }}</span> - CPF: {{ getCpfAvalista(avalista.cpf) }}</small></p>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="panel panel-small" *ngIf="isFavorecido">
  <form class="forms">
    <div class="form-group">
      <span class="icon pessoas"></span>
      <div class="inputs">
        <label for="cliente">FAVORECIDO</label>
        <p><small> <span class="name">{{ nomeFavorecido }}</span> - CPF: {{ cpfFavorecido }}</small></p>
      </div>
    </div>
  </form>
</div>
<div class="panel panel-small">
  <form class="forms">
    <div class="form-group">
      <span class="icon ficha-finalizada-condicoes"></span>
      <div class="inputs">
        <label for="cliente">CONDIÇÕES</label>
        <p><small> {{proposta?.valorLiquido | currency:'BRL':'symbol':'1.2-2'}} em {{ proposta?.qtdeParcelas }} x de
            {{ proposta?.valorParcela | currency:'BRL':'symbol':'1.2-2'}} </small></p>
      </div>
    </div>
  </form>
</div>
<div class="standalone-text">
  <p>
    Agora é só aguardar os próximos passos!
  </p>
</div>
